<editor
  #editor
  [init]="editorConfig"
  (onFocusIn)="onEditorFocusIn()"
  (onFocusOut)="onEditorFocusOut()"
  (onPaste)="onEditorPaste()"
  (onKeyUp)="onEditorKeyUp()"
  [disabled]="isDisabled"
></editor>
